<template>
    <!-- <div
        ref="header"
        class="header sticky top-0"
        :class="{
            'px-20 pb-0': store.isOnMapAppPage,
            'z-50 bg-white pb-6': !store.isOnMapAppPage,
        }"
    > -->
    <div
        ref="header"
        class="header sticky top-0 z-50 bg-white pb-3"
    >
        <div
            ref="upperHeaderPart"
            class="flex h-[85px] items-center justify-between border-b border-black-text bg-white pt-6 xl:h-[90px] xl:pt-4 px-10"
        >
            <div class="flex gap-4 items-center">
                <NuxtLink
                    to="/"
                    target="_self"
                    class="flex items-center gap-4"
                >
                    <div class="w-28 xl:w-40">
                        <img
                            src="/img/ipr_logo.png"
                            class="relative w-full"
                        />
                    </div>
                </NuxtLink>
                <div class="font-promedium text-3xl">
                    Evidence okrskářů Městské policie HMP
                </div>
            </div>
            <!-- <div class="flex gap-12">
                <div class="flex items-center gap-3 xl:gap-9">
                    <NuxtLink
                        v-for="item in store.pages"
                        :key="item.to"
                        :to="item.to"
                        class="px-2 py-0.5 font-promedium hover:bg-black-text hover:text-white xl:px-3"
                        :class="{
                            'bg-black-text': route.path.includes(item.to),
                            'text-white': route.path.includes(item.to),
                        }"
                    >
                        {{ item.title }}
                    </NuxtLink>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script setup lang="ts">
const store = useMainStore()
// const route = useRoute()

const header = ref<HTMLElement | null>(null)
const upperHeaderPart = ref<HTMLElement | null>(null)

onMounted(() => {
    nextTick(() => {
        setHeaderHeight()
    })
})

function setHeaderHeight() {
    const toolbarHeight = 44
    store.headerHeight = header.value
        ? header.value.clientHeight + toolbarHeight
        : toolbarHeight
}
</script>

<style></style>
